import { useEffect } from "react";

const sections = [
  {
    id: "01",
    title: "Who We Are",
    content: [
      "India Business Helpline (IBH) is a business advisory and compliance services platform.",
      "__bold__Email: indianbusinesshelpline@gmail.com",
      "__italic__For any privacy-related queries, write to us at the email address above.",
    ],
  },
  {
    id: "02",
    title: "Information We Collect",
    subsections: [
      {
        label: "Personal Information",
        items: [
          "Full name",
          "Email address",
          "Phone number",
          "Business name",
          "Postal address",
          "GST Number or PAN (only where required for specific services)",
          "Any information voluntarily provided through forms, emails, enquiries, or consultations",
        ],
      },
      {
        label: "Technical Information",
        items: [
          "IP address",
          "Browser type and version",
          "Device information",
          "Pages visited and time spent",
          "Date and time of visit",
          "Cookies and usage data",
        ],
      },
      {
        label: "Business Information",
        items: [
          "When you seek advisory, compliance, or documentation services from us, we may collect relevant business, financial, or legal information necessary to deliver those services effectively.",
        ],
      },
    ],
  },
  {
    id: "03",
    title: "Legal Basis for Processing",
    items: [
      "Consent — when you submit a form, sign up, or reach out to us.",
      "Performance of a contract — when you engage us for a service or advisory.",
      "Legitimate interests — to operate, improve, and secure our platform and services.",
      "Legal obligation — to comply with applicable laws, regulations, and statutory requirements in India.",
    ],
  },
  {
    id: "04",
    title: "How We Use Your Information",
    items: [
      "Provide, manage, and improve our services",
      "Respond to enquiries, consultation requests, and support queries",
      "Process registrations, documentation, and compliance-related work",
      "Send relevant updates, service announcements, and offers (only to users who have opted in)",
      "Improve website functionality and user experience",
      "Maintain internal business and accounting records",
      "Comply with legal, regulatory, and statutory obligations applicable in India",
    ],
  },
  {
    id: "05",
    title: "Sharing of Information",
    content: ["We do not sell your personal information. We may share information only in the following circumstances:"],
    items: [
      "Service providers — consultants, accountants, legal professionals, technology partners engaged to support our operations, strictly on a need-to-know basis.",
      "Government and regulatory authorities — when required by law, court order, or applicable regulation.",
      "Law enforcement — where legally mandated or to protect the rights, safety, and interests of our users or IBH.",
    ],
    footer: "All third parties with whom we share data are bound by confidentiality obligations and are not permitted to use your information for any purpose other than the one specified.",
  },
  {
    id: "06",
    title: "Cookies & Analytics",
    content: ["Our website uses cookies and similar tracking technologies to:"],
    items: [
      "Enable core website functionality",
      "Analyse website traffic and user behaviour",
      "Improve website performance and user experience",
      "Remember user preferences across sessions",
    ],
    footer: "You may disable cookies at any time through your browser settings. Please note that disabling cookies may affect certain parts of the website experience.",
  },
  {
    id: "07",
    title: "Third-Party Links",
    content: [
      "Our website may contain links to third-party websites or external platforms. IBH is not responsible for the content, privacy practices, or security of any third-party sites. We encourage you to review the privacy policies of any external website you visit.",
    ],
  },
  {
    id: "08",
    title: "Data Retention",
    content: ["We retain personal information for as long as necessary to:"],
    items: [
      "Deliver the services you have requested",
      "Meet legal, regulatory, and accounting obligations",
      "Resolve disputes or enforce agreements",
    ],
    footer: "Once information is no longer required, we will delete or anonymise it in a secure manner.",
  },
  {
    id: "09",
    title: "Your Rights",
    content: ["Subject to applicable law, you have the right to:"],
    items: [
      "Access the personal information we hold about you",
      "Request correction of any inaccurate or incomplete data",
      "Request deletion of your data, where legally permissible",
      "Withdraw consent for marketing communications at any time",
      "Object to or restrict processing in certain circumstances",
    ],
    footer: "To exercise any of these rights, write to us at indianbusinesshelpline@gmail.com. We will respond within a reasonable timeframe.",
  },
  {
    id: "10",
    title: "Data Security",
    content: [
      "We implement reasonable administrative, technical, and organisational measures to protect your personal information from unauthorised access, disclosure, alteration, or destruction.",
      "While we take the protection of your data seriously, no online platform or electronic storage system can guarantee absolute security. Users access the website and share information at their own discretion.",
    ],
  },
  {
    id: "11",
    title: "Limitation of Liability",
    content: ["IBH shall not be liable for:"],
    items: [
      "Unauthorised access resulting from cyberattacks or security breaches beyond our reasonable control",
      "Temporary website unavailability or downtime",
      "Loss or damage arising from reliance on third-party platforms, tools, or external links",
    ],
  },
  {
    id: "12",
    title: "Changes to This Policy",
    content: [
      "IBH reserves the right to modify or update this Privacy Policy at any time. The most current version will always be published on this page with the revised effective date. We encourage you to review this page periodically.",
    ],
  },
  {
    id: "13",
    title: "Contact Us",
    content: [
      "If you have any questions, concerns, or requests regarding this Privacy Policy or how your data is handled, please contact us:",
      "__bold__India Business Helpline (IBH)",
      "Email: indianbusinesshelpline@gmail.com",
      "__italic__Your privacy is important to us. Thank you for trusting IBH.",
    ],
  },
];

export default function PrivacyPolicy() {
  useEffect(() => {
    window.scrollTo({ top: 0, behavior: "instant" });
  }, []);

  return (
    <div style={{ fontFamily: "'DM Sans', 'Helvetica Neue', sans-serif", background: "#f8f8fc", minHeight: "100vh" }}>
      <style>{`
        * { box-sizing: border-box; }

        .header-gradient {
          background: linear-gradient(135deg, #1a1a2e 0%, #2d1b5e 60%, #1a2e4a 100%);
          padding: 48px 40px 40px;
          position: relative;
          overflow: hidden;
        }
        .header-gradient::before {
          content: '';
          position: absolute;
          top: -60px; right: -60px;
          width: 300px; height: 300px;
          border-radius: 50%;
          background: radial-gradient(circle, rgba(249,115,22,0.18) 0%, transparent 70%);
        }
        .header-gradient::after {
          content: '';
          position: absolute;
          bottom: -40px; left: 20%;
          width: 200px; height: 200px;
          border-radius: 50%;
          background: radial-gradient(circle, rgba(139,92,246,0.2) 0%, transparent 70%);
        }

        .back-btn {
          display: inline-flex;
          align-items: center;
          gap: 7px;
          color: rgba(255,255,255,0.6);
          font-size: 13px;
          font-weight: 500;
          cursor: pointer;
          border: none;
          background: rgba(255,255,255,0.08);
          font-family: 'Inter', sans-serif;
          margin-bottom: 24px;
          transition: color 0.15s;
          padding: 6px 14px;
          border-radius: 20px;
        }
        .back-btn:hover { color: rgba(255,255,255,0.9); }

        .section-card {
          background: #fff;
          border-radius: 16px;
          border: 1px solid #ebebf5;
          padding: 28px 32px;
          transition: box-shadow 0.2s ease;
        }
        .section-card:hover {
          box-shadow: 0 8px 32px rgba(0,0,0,0.07);
        }

        .section-id {
          font-family: 'Inter', sans-serif;
          font-size: 11px;
          font-weight: 600;
          letter-spacing: 0.08em;
          color: #F97316;
          margin-bottom: 8px;
        }

        .section-title {
          font-family: 'Poppins', sans-serif;
          font-size: 17px;
          font-weight: 700;
          color: #1a1a2e;
          margin-bottom: 14px;
        }

        .section-text {
          font-family: 'Inter', sans-serif;
          font-size: 14px;
          color: #4a4a6a;
          line-height: 1.75;
          margin-bottom: 8px;
        }

        .section-item {
          display: flex;
          align-items: flex-start;
          gap: 10px;
          font-family: 'Inter', sans-serif;
          font-size: 14px;
          color: #4a4a6a;
          line-height: 1.7;
          margin-bottom: 8px;
        }

        .section-item-dot {
          width: 6px;
          height: 6px;
          border-radius: 50%;
          background: #F97316;
          margin-top: 8px;
          flex-shrink: 0;
        }

        .subsection-label {
          font-family: 'Inter', sans-serif;
          font-size: 13px;
          font-weight: 600;
          color: #1a1a2e;
          margin: 14px 0 8px;
        }

        .footer-note {
          font-family: 'Inter', sans-serif;
          font-size: 12px;
          color: #9090b0;
          font-style: italic;
          margin-top: 12px;
          padding-top: 12px;
          border-top: 1px solid #f0f0fa;
        }

        @media (max-width: 768px) {
          .header-gradient { padding: 32px 20px 28px; }
          .content-area { padding: 20px !important; }
          .section-card { padding: 20px; }
        }
      `}</style>

      {/* ── HEADER — exact copy from ExpertsPage ── */}
      <div className="header-gradient">
        <button className="back-btn" onClick={() => window.history.back()}>
          &lt; Back
        </button>
        <div style={{ position: "relative", zIndex: 1 }}>
          <h1 style={{
            fontFamily: "'Poppins', sans-serif",
            fontSize: "clamp(28px, 5vw, 42px)",
            fontWeight: 700,
            color: "#fff",
            lineHeight: 1.15,
            marginBottom: 10,
          }}>
            Privacy{" "}
            <span style={{
              background: "linear-gradient(90deg, #F97316, #EC4899, #8B5CF6)",
              WebkitBackgroundClip: "text",
              WebkitTextFillColor: "transparent",
              fontFamily: "'Poppins', sans-serif",
              fontWeight: 700,
              fontSize: "inherit",
            }}>
              Policy
            </span>
          </h1>
          <p style={{
            color: "rgba(255,255,255,0.6)",
            fontSize: 15,
            maxWidth: 480,
            lineHeight: 1.6,
            fontFamily: "'Inter', sans-serif",
          }}>
            India Business Helpline is committed to protecting your privacy.
          </p>
        </div>
      </div>

      {/* ── CONTENT ── */}
      <div
        className="content-area"
        style={{ padding: "32px 40px 60px", display: "flex", flexDirection: "column", gap: 16 }}
      >
        {sections.map((section) => (
          <div key={section.id} className="section-card">
            <div className="section-id">SECTION {section.id}</div>
            <div className="section-title">{section.title}</div>

            {/* Intro paragraphs */}
            {section.content?.map((para, i) => (
              <p key={i} className="section-text">
                {para.startsWith("__bold__")
                  ? <strong>{para.replace("__bold__", "")}</strong>
                  : para.startsWith("__italic__")
                  ? <em>{para.replace("__italic__", "")}</em>
                  : para}
              </p>
            ))}

            {/* Subsections */}
            {section.subsections?.map((sub, si) => (
              <div key={si}>
                <div className="subsection-label">{sub.label}</div>
                {sub.items.map((item, ii) => (
                  <div key={ii} className="section-item">
                    <span className="section-item-dot" />
                    <span>{item}</span>
                  </div>
                ))}
              </div>
            ))}

            {/* Bullet items */}
            {section.items?.map((item, i) => (
              <div key={i} className="section-item">
                <span className="section-item-dot" />
                <span>{item}</span>
              </div>
            ))}

            {/* Footer note */}
            {section.footer && (
              <div className="footer-note">{section.footer}</div>
            )}
          </div>
        ))}

        {/* Bottom strip */}
        <div style={{
          marginTop: 8,
          paddingTop: 24,
          borderTop: "1px solid #ebebf5",
          display: "flex",
          flexWrap: "wrap",
          justifyContent: "space-between",
          alignItems: "center",
          gap: 8,
          fontFamily: "'Inter', sans-serif",
          fontSize: 12,
          color: "#9090b0",
        }}>
          <span>© {new Date().getFullYear()} India Business Helpline. All rights reserved.</span>
          <a href="mailto:indianbusinesshelpline@gmail.com" style={{ color: "#F97316", textDecoration: "none" }}>
            indianbusinesshelpline@gmail.com
          </a>
        </div>
      </div>
    </div>
  );
}